import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
const contactBackground = '/main-bg-golden.png';

const Contact = () => {
  useDocTitle('Contact - Marquee Commodity Group');
  const backgroundImage = contactBackground;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    const subject = 'Contact Form Submission';
    const body = `First Name: ${firstName}\nLast Name: ${lastName}\nEmail: ${email}\nPhone: ${phone}\n\n${message}`;
    const mailtoLink = `mailto:orders@marqueecommoditygroup.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <>
      <NavBar />

      {/* Hero banner */}
      <div className="relative h-[40vh] md:h-[50vh]">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/40 to-navy-900/60" />
        <div className="relative z-10 h-full flex items-center justify-center">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-bold tracking-wide">
            Contact Us
          </h1>
        </div>
      </div>

      {/* Form section */}
      <div id="contact" className="dark-section py-12 md:py-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12">
            {/* Form */}
            <div className="lg:col-span-3">
              <form onSubmit={sendEmail} className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="first_name"
                    className="w-full bg-navy-900/50 border border-gold-500/20 text-cream-200 placeholder-cream-300/40 px-4 py-3 rounded focus:outline-none focus:border-gold-400 transition-colors font-sans text-sm"
                    type="text"
                    placeholder="First Name*"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                  <input
                    name="last_name"
                    className="w-full bg-navy-900/50 border border-gold-500/20 text-cream-200 placeholder-cream-300/40 px-4 py-3 rounded focus:outline-none focus:border-gold-400 transition-colors font-sans text-sm"
                    type="text"
                    placeholder="Last Name*"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="email"
                    className="w-full bg-navy-900/50 border border-gold-500/20 text-cream-200 placeholder-cream-300/40 px-4 py-3 rounded focus:outline-none focus:border-gold-400 transition-colors font-sans text-sm"
                    type="email"
                    placeholder="Email*"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <input
                    name="phone"
                    className="w-full bg-navy-900/50 border border-gold-500/20 text-cream-200 placeholder-cream-300/40 px-4 py-3 rounded focus:outline-none focus:border-gold-400 transition-colors font-sans text-sm"
                    type="tel"
                    placeholder="Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <textarea
                  name="message"
                  className="w-full h-36 bg-navy-900/50 border border-gold-500/20 text-cream-200 placeholder-cream-300/40 px-4 py-3 rounded focus:outline-none focus:border-gold-400 transition-colors font-sans text-sm resize-none"
                  placeholder="Your Message*"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="px-10 py-3 bg-navy-800 text-gold-400 border border-gold-500/50 font-semibold tracking-[0.15em] text-sm hover:bg-navy-900 hover:border-gold-400 transition-all duration-300"
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>

            {/* Contact info */}
            <div className="lg:col-span-2 flex flex-col justify-center">
              <div className="space-y-6">
                <div>
                  <h3 className="font-serif text-gold-400 text-lg mb-2">
                    Email
                  </h3>
                  <a
                    href="mailto:orders@marqueecommoditygroup.com"
                    className="font-body text-cream-300/70 hover:text-gold-400 transition-colors text-sm"
                  >
                    orders@marqueecommoditygroup.com
                  </a>
                </div>
                <div>
                  <h3 className="font-serif text-gold-400 text-lg mb-2">
                    LinkedIn
                  </h3>
                  <a
                    href="https://ca.linkedin.com/in/bentleygurparmbrar"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 font-body text-cream-300/70 hover:text-gold-400 transition-colors text-sm"
                  >
                    <svg
                      className="w-5 h-5"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    Bentley G.S. Brar
                  </a>
                </div>
                <div>
                  <h3 className="font-serif text-gold-400 text-lg mb-2">
                    Headquarters
                  </h3>
                  <p className="font-body text-cream-300/70 text-sm">
                    Canada
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;
